import { render } from "./mentions-legalesComponent.vue?vue&type=template&id=2d43b589"
import script from "./mentions-legalesComponent.vue?vue&type=script&lang=js"
export * from "./mentions-legalesComponent.vue?vue&type=script&lang=js"

import "./mentions-legalesComponent.vue?vue&type=style&index=0&id=2d43b589&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__